import React from "react"
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"
import styled from "styled-components"

const Champ = styled.div`
margin:10px auto;
padding: 0;
`
const ElementFormSearch = (params) => {

  const {onSubmit} = params
  const initialValues = {
    critere: ""
  }


  const validationSchema = Yup.object().shape({
    critere: Yup.string()
  })

  const FormulaireJSX = () => {
      return(<Form>
          <Champ>
            <label>Critere</label>
            <Field name="critere" type="text" className="form-control" size="40"/>
            <button type="submit" onSubmit={onSubmit}>Rechercher</button>
          </Champ>
          </Form>)
  }

  return (<Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}>
    <FormulaireJSX/>
  </Formik>)
}
export default ElementFormSearch